const ARROWS_POSITION = {
  ON_GALLERY: 'ON_GALLERY',
  OUTSIDE_GALLERY: 'OUTSIDE_GALLERY',
  MOUSE_CURSOR: 'MOUSE_CURSOR',
};

export default ARROWS_POSITION;
